import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DotService {
  private _toggle = new Subject();
  toggle$ = this._toggle.asObservable();

  toggle(visible: boolean) {
    this._toggle.next(visible);
  }
}
